// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"31c97bd0","977":"31a11308"}[chunkId] + ".chunk.js";
};